import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import AboutSection from '../components/AboutSection';
import TreatmentSection from '../components/TreatmentSection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhyChooseUs from '../components/WhyChooseUs';
import FaqSection from '../components/FaqSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import ChiropracticInfo from '../components/ChiropracticInfo';
import SpecialtiesSection from '../components/SpecialtiesSection';

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <AboutSection />
      <SpecialtiesSection />
      <ChiropracticInfo />
      <TreatmentSection />
      <TestimonialsSection />
      <WhyChooseUs />
      <FaqSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Index;
